// extracted by mini-css-extract-plugin
module.exports = {"donation":"kH","donationIcon":"kI","donationTitle":"kJ"};